import { Box } from "@/Components/v2/atoms/Box";
import { useTheme } from "@mui/material";
import { useScenarioActionBanner } from "../hooks/useScenarioActionBanner";
import { ScenarioOption } from "../../../components/NewActionPlanModal/types";
import { ActionPlanSummary } from "@mutiny-group/sbo-openapi-client";
import ApproveScenarioForActionPlanModal from "../../../components/ApproveScenarioForActionPlanModal";
import { NewActionPlanModal } from "../../../components/NewActionPlanModal/NewActionPlanModal";
import { useState } from "react";
import {
  ApproveActionBanner,
  ApprovedActionBanner,
  CreateActionBanner,
  ApproveManyActionBanner,
} from "./scenarioActionBanner/index";

type ScenarioActionBannerProps = {
  eligibleActionPlans: ActionPlanSummary[];
  approvedActionPlans: ActionPlanSummary[];
  scenarioOption: ScenarioOption;
};

const ScenarioActionBanner = ({
  eligibleActionPlans,
  approvedActionPlans,
  scenarioOption,
}: ScenarioActionBannerProps) => {
  const theme = useTheme();

  // Modal state management
  const [newActionPlanOpen, setNewActionPlanOpen] = useState(false);
  const [approveModalOpen, setApproveModalOpen] = useState(false);

  const {
    bannerStyle,
    bannerState,
    handleApproveScenario,
    eligibleActionPlan,
    approvedActionPlan,
    isApprovePending,
    setEligibleActionPlan,
    navigateToActionPlan,
  } = useScenarioActionBanner({
    theme,
    eligibleActionPlans,
    approvedActionPlans,
    scenarioOption,
    setApproveModalOpen,
  });

  const viewEligibleActionPlan = () => {
    if (!eligibleActionPlan?.uuid) return;
    navigateToActionPlan(eligibleActionPlan.uuid);
  };

  const viewApprovedActionPlan = () => {
    if (!approvedActionPlan?.uuid) return;
    navigateToActionPlan(approvedActionPlan.uuid);
  };

  const approveActionPlan = () => {
    if (!eligibleActionPlan?.uuid) return;
    setApproveModalOpen(true);
  };

  const createActionPlan = () => {
    setNewActionPlanOpen(true);
  };

  return (
    <Box
      sx={{
        ...bannerStyle.style.banner,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 2,
        borderRadius: 2,
        mt: 3,
      }}
    >
      {bannerState === "approved" && (
        <ApprovedActionBanner onViewClick={viewApprovedActionPlan} bannerStyle={bannerStyle} />
      )}
      {bannerState === "approve" && (
        <ApproveActionBanner
          onViewClick={viewEligibleActionPlan}
          onApproveClick={approveActionPlan}
          bannerStyle={bannerStyle}
        />
      )}
      {bannerState === "approveMany" && (
        <ApproveManyActionBanner
          onViewClick={viewEligibleActionPlan}
          onApproveClick={approveActionPlan}
          onCreateClick={createActionPlan}
          setEligibleActionPlan={setEligibleActionPlan}
          eligibleActionPlans={eligibleActionPlans}
          eligibleActionPlan={eligibleActionPlan}
          bannerStyle={bannerStyle}
        />
      )}
      {bannerState === "create" && (
        <CreateActionBanner onCreateClick={createActionPlan} bannerStyle={bannerStyle} />
      )}

      <NewActionPlanModal
        open={newActionPlanOpen}
        handleClose={() => setNewActionPlanOpen(false)}
        scenarioOption={scenarioOption}
      />
      <ApproveScenarioForActionPlanModal
        open={approveModalOpen}
        onClose={() => setApproveModalOpen(false)}
        onApprove={() => handleApproveScenario()}
        isApprovePending={isApprovePending}
        scenarioOption={scenarioOption}
        actionPlan={eligibleActionPlan}
      />
    </Box>
  );
};

export default ScenarioActionBanner;
